/**
 * ContactUsPage - Generated page component.
 */
import React, { useEffect } from 'react';
import HeroCard from '../components/cards/HeroCard';
import SectionTitleCard from '../components/cards/SectionTitleCard';
import ContactFormCard from '../components/cards/ContactFormCard';
import ContactInfoCard from '../components/cards/ContactInfoCard';

const ContactUsPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Contact Us | Kuiken Technologies LLC.';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '');
  }, []);

  return (
    <main>

      <section className="layout-full section-padding" aria-label="ContactHero">

            <HeroCard title={"Contact Us"} subtitle={"Let's talk about your goals and how we can help."} image={"https://images.unsplash.com/photo-1523958203904-cdcb402031fd?auto=format&fit=crop&w=2400&q=80"} height={360} overlay={true} text_color={"#e9f0ec"} variant={"ImageOverlay"}/>
      </section>
      <section className="layout-container section-padding" aria-label="ContactMain">

            <SectionTitleCard title={"Get in touch"} subtitle={"Send us a message or reach out directly — we respond within one business day."}/>
            <ContactFormCard title={"Send us a message"} subtitle={"Tell us about your project and we'll get back to you shortly."} showPhone={true} showSubject={true} successMessage={"Thank you for reaching out! We'll be in touch within one business day."}/>
            <ContactInfoCard columns={3} items={[{"label": "Email", "value": "Adam@Kuiken.tech", "action": "mailto:Adam@Kuiken.tech", "type": "email"}, {"label": "Phone", "value": "+1-708-674-0833", "action": "tel:+17086740833", "type": "phone"}, {"label": "LinkedIn", "value": "linkedin.com/in/adam-kuiken", "action": "https://www.linkedin.com/in/adam-kuiken/", "type": "external", "target": "_blank"}]} variant={"LinkGrid"}/>
      </section>
    </main>
  );
};

export default ContactUsPage;
